import { useConfirmationDialog } from '@dashhudson/dashing-ui/confirmation-dialog';

import { CLEAR_CHAT_HISTORY_CONFIRMATION_MESSAGE } from '@/components/VisionAi/constants';
import { useVisionAiStore } from '@/stores/vision-ai';

export function useClearChatHistoryConfirmation() {
  const visionAiStore = useVisionAiStore();

  const { showConfirmationDialog: showClearChatHistoryConfirmation } = useConfirmationDialog({
    group: 'global',
    header: 'Delete Chat History?',
    message: CLEAR_CHAT_HISTORY_CONFIRMATION_MESSAGE,
    acceptLabel: 'Delete',
    acceptSeverity: 'danger',
    onAccept: () => visionAiStore.handleClearChatHistory(),
  });

  return { showClearChatHistoryConfirmation };
}
